// store.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import deviceReducer from './deviceSlice'; // Import the device slice
import sensorReducer from './sensorSlice'

const store = configureStore({
  reducer: {
    user: userReducer,
    device: deviceReducer,
    sensor: sensorReducer, // Add sensor reducer to the store

  },
});

export default store;
